import axios from 'axios'

export default {
    createUpdateProductBulkPrices(prices) {
        return axios.post(process.env.VUE_APP_BACKEND_BASE_URL + '/bulkprices', prices).then((response) => {
            return response
        })
    },
    getBulkPricesForProduct(productId) {
        return axios.get(process.env.VUE_APP_BACKEND_BASE_URL + '/bulkprices/' + productId).then((response) => {
            return response
        })
    },
}
